import { Button, Flex, Strong, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '~/components/Icon';
import DragAndDropUploadFile from '~/components/Input/Elements/DragAndDropUploadFile';
import SiteContainer from '~/components/SiteContainer';

function AdminUploadService({ file, setFile, uploadFile, loading, fileTitle, nounPlural }) {
  return (
    <SiteContainer>
      <Flex
        direction='column'
        gap='4'
      >
        <DragAndDropUploadFile
          allowedMimeTypes={['text/csv']}
          allowedExtensions={['.csv']}
          onFile={file => setFile(file)}
          fileTitle={fileTitle}
        />
        <Flex justify='between'>
          <Flex
            align='center'
            gap='2'
          >
            <Icon
              name='info-circle'
              width='16'
              height='16'
              inline
              color='var(--gray-a11)'
            />
            <Text>
              <Strong>Note:</Strong> All old {nounPlural} will be removed
            </Text>
          </Flex>
          <Flex
            align='center'
            gap='2'
          >
            <Text>File: {file ? file.name : 'None yet'}</Text>
            <Button
              onClick={uploadFile}
              disabled={!file}
              variant='outline'
              radius='full'
              color='gray'
            >
              {loading ? 'Uploading...' : 'Upload'}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </SiteContainer>
  );
}

AdminUploadService.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
  }),
  setFile: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fileTitle: PropTypes.string,
  nounPlural: PropTypes.string,
};

export default AdminUploadService;
